import { render, staticRenderFns } from "./DetailsTransference.vue?vue&type=template&id=7c0ef676"
import script from "./DetailsTransference.vue?vue&type=script&lang=js"
export * from "./DetailsTransference.vue?vue&type=script&lang=js"
import style0 from "./DetailsTransference.vue?vue&type=style&index=0&id=7c0ef676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports